// **********************************************************
// Map Modal
// **********************************************************

const mapMainSlider = document.querySelectorAll('[data-slider="map-main-slider"]');
const thumbThumbSlider = document.querySelectorAll('[data-slider="map-thumb-slider"]');
const zoomInstances = new Map();
const MODAL_TRANSITION_MS = 400;

const refreshZoom = (container) => {
  if (!container) return;

  container.querySelectorAll('[data-image-zoom-parent]').forEach((zoomParent) => {
    zoomInstances.get(zoomParent)?.prepare();
  });
};

const prepareZoom = (container) => {
  if (!container) return;

  container.querySelectorAll('[data-image-zoom-parent]').forEach((zoomParent) => {
    const instance = zoomInstances.get(zoomParent);

    if (!instance) return;

    instance.maxZoomDown();
    zoomParent.classList.remove('is-zoom');
  });
};

// *******************************************************************************
// 1.1 - Gallery Thumb Slider
// *******************************************************************************

const thumbThumbSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  watchOverflow: true,
  allowTouchMove: false,
  simulateTouch: false,
  effect: 'fade',
  fadeEffect: { crossFade: true },
};

thumbThumbSlider.forEach((el) => new Swiper(el, thumbThumbSliderOptions));

// *******************************************************************************
// 1.2 -Gallery Main Slider
// *******************************************************************************

const mapMainSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  allowTouchMove: false,
  simulateTouch: false,
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  effect: 'fade',
  fadeEffect: { crossFade: true },
};

mapMainSlider.forEach((el, i) => {
  const mapMainSliderParent = el.closest('.map-modal');
  const arrowRight = mapMainSliderParent.querySelector('.arrow-right');
  const arrowLeft = mapMainSliderParent.querySelector('.arrow-left');

  new Swiper(el, {
    ...mapMainSliderOptions,
    navigation: {
      ...mapMainSliderOptions.navigation,
      nextEl: arrowRight,
      prevEl: arrowLeft,
    },
    thumbs: {
      ...mapMainSliderOptions.thumbs,
      swiper: thumbThumbSlider[i].swiper,
    },

    on: {
      slideChangeTransitionEnd() {
        prepareZoom(mapMainSliderParent);
      },
    },
  });
});

// Zoom Toggle

const imageZoomParents = document.querySelectorAll('[data-image-zoom-parent]');

imageZoomParents.forEach((parent) => {
  const imageParent = parent.querySelector('.map-modal__floor-image');
  const image = parent.querySelector('[data-image-zoom]');
  const zoomBtn = parent.querySelector('.map-modal__zoom');

  if (!image || !zoomBtn) return;

  let isPointerDown = false;
  let isDragging = false;

  const wzoom = WZoom.create(image, {
    minScale: 1,
    maxScale: 2.5,
    zoomOnClick: false,
    smoothTimeDrag: 0.1,
    onGrab: () => {
      imageParent.style.cursor = 'grabbing';
    },
    onDrop: () => {
      imageParent.style.cursor = 'grab';
    },
    rescale(instance) {
      parent.classList.toggle('is-zoom', instance.content.currentScale > instance.content.minScale);
    },
  });

  zoomInstances.set(parent, wzoom);

  const toggleZoom = () => {
    // eslint-disable-next-line no-unused-expressions
    parent.classList.contains('is-zoom') ? wzoom.maxZoomDown() : wzoom.maxZoomUp();
  };

  zoomBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleZoom();

    document.querySelectorAll('.map-modal__info.is-open').forEach((infoModal) => {
      infoModal.classList.remove('is-open');
    });
  });

  image.addEventListener('pointerdown', () => {
    isPointerDown = true;
    isDragging = false;
  });

  image.addEventListener('pointermove', () => {
    if (isPointerDown) {
      isDragging = true;
    }
  });

  const endPointer = () => {
    isPointerDown = false;
  };

  image.addEventListener('pointerup', endPointer);
  image.addEventListener('pointercancel', endPointer);
  image.addEventListener('pointerleave', endPointer);

  image.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
      return;
    }

    toggleZoom();
  });
});

window.addEventListener(
  'resize',
  debounce(() => {
    const openModal = document.querySelector('.map-modal.is-open-modal');

    if (openModal) {
      refreshZoom(openModal);
    }
  }, 150),
);

// Open Info

attachEvent('.map-modal__legend-trigger', 'click', (ev) => {
  ev.stopPropagation();
  const parentElem = ev.target.closest('.map-modal');
  const infoModal = parentElem?.querySelector('.map-modal__info');
  infoModal?.classList.toggle('is-open');
});

document.addEventListener('click', (ev) => {
  if (ev.target.closest('.map-modal__info') || ev.target.closest('.map-modal__legend-trigger')) {
    return;
  }

  document.querySelectorAll('.map-modal__info.is-open').forEach((infoModal) => {
    infoModal.classList.remove('is-open');
  });
});

// Toggle Modal
const toggleMapModalClass = (toggle) => {
  const mapModal = document.querySelector('.map-modal');
  mapModal?.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);

  setTimeout(() => {
    if (toggle) {
      refreshZoom(mapModal); // Recalculate WZoom after modal is visible
    } else {
      prepareZoom(mapModal); // Reset zoom after modal closes
    }
  }, MODAL_TRANSITION_MS);
};

attachEvent('[data-map-toggle]', 'click', () => {
  toggleMapModalClass(true);
});

attachEvent('[data-map-modal-close]', 'click', () => {
  toggleMapModalClass(false);
});

onKeydown('escape', () => toggleMapModalClass(false));
